export default __webpack_public_path__ + "static/media/Mark-2-Suit-Cycles-09.6c8a9898.jpg";